import { createContext, useContext } from "react";

export const CommunityShellContext = createContext(false);

export const useCommunityShell = () => useContext(CommunityShellContext);
